<template lang="html">
  <section class="form-box" :class="{incompleted: !forditasTeljesitesenekModja}">
    <div class="container">

      <div class="row">
        <h2 class="urlap-title">Fordítás teljesítése<span class="required-field">*</span></h2>
      </div>

      <div class="row">
        <div class="teljesites-icons">
          <div class="ico" v-for="(data,key) in teljesitesiModok" v-bind:key="key" :value="key">
            <input
              class="hidden"
              type="radio"
              v-model="forditas_teljesitese"
              name="teljesites-icon"
              :value="key"
              :id="'teljesites-'+key"
            />
            <label :for="'teljesites-'+key">
              <img :src="'/wp-content/themes/lebe-childtheme/assets/images/ico/teljesitesmodja/'+key+'.png'">
              <span>
                <div class="teljesites-label-row" v-for="(row,key) in data['label'].split(',')" v-bind:key="key" :value="key">
                {{row}}</div>
              </span>
            </label>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import {fieldMixin} from '../../mixin/field'

export default {
  mixins: [
    fieldMixin
  ],
  props: [
    'forditasTeljesitesenekModja',
    'specialization'
  ],
  computed: {
    forditas_teljesitese: {
      get() {
        return this.forditasTeljesitesenekModja
      },
      set(val) {
        this.$emit('update:forditasTeljesitesenekModja',val)
      }
    },
    hitelesitheto_specializacio() {
      return this.specialization == "ceges_okirat"
    },
    teljesitesiModok() {
      let teljesitesiModok = new Object()
      for(const objKey in this.fieldOptions) {
        if(
          //a teljesítési mód nem tartalmaz hitelesítést
          !this.hietelesitesesTeljesitesiMod(objKey)
          //a specializáció hitelesíthető és a teljesítési mód hitelesítést tartalmaz
          || this.hitelesitheto_specializacio
          && this.hietelesitesesTeljesitesiMod(objKey)
        ) {
          teljesitesiModok[objKey] = this.fieldOptions[objKey]
        }
      }
      return teljesitesiModok
    }
  },
  methods: {
    hietelesitesesTeljesitesiMod(teljesitesiMod) {
      return teljesitesiMod.includes("hiteles")
    }
  },
  watch: {
    specialization: function() {
      this.forditas_teljesitese = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_variables';
.form-group{
  padding: 0 .5em;
}
.teljesites-icons{
  display: flex;
  flex: 1 1 0px;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  .ico{
    margin-left: 1.3%;
    margin-bottom: 1.3%;
    width: 48%;
    min-width: 300px;
    label{
      border: 1px solid #ddd;
      background-color: #f7f7f7;
      padding: 5px 15px;
      margin: 0;
      font-weight: normal;
      font-size: 14px;
      line-height: 1.5em;
      width: 100%;
      display: flex;
      align-items: center;
      img{
        height: 48px;
        margin-right: 12px;
      }
      span{
        font-weight: 600;
        color: $secondary-color;
      }
    }
    input[type="radio"]:checked+label {
      background-color: #eaf2ff;
      border-color: #337ab7;
    }
  }
}
.teljesites-label-row:not(:last-child)::after{
  content: ',';
}
</style>
